import React, { useCallback } from 'react';
import { NoAlerts } from './NoAlerts';
import { Warning } from '../../Warning/Warning';
import { useModal } from '@topconagriculture/modal';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import { WidgetFooter } from '../WidgetFooter';
import { Loader } from '@topconagriculture/loader';
import { deviationGeneralAlertsModalName } from './DeviationWidget';
import { useDeviationAlertsSummarySubscription } from './hooks/useDeviationAlertsSummarySubscription';
const useStyles = makeStyles(() => ({
    container: {
        textTransform: 'capitalize',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}));
export const DeviationWidgetXS = ({ link, widget }) => {
    const { data, isLoading } = useDeviationAlertsSummarySubscription(widget.type);
    const alertsCount = ((data === null || data === void 0 ? void 0 : data.overWeightCount) || 0) + ((data === null || data === void 0 ? void 0 : data.underWeightCount) || 0);
    const { dispatchOpenModal } = useModal();
    const { t } = useTranslation();
    const classes = useStyles();
    const openModal = useCallback(() => dispatchOpenModal({
        modalName: deviationGeneralAlertsModalName,
        modalParams: { link, widget },
        modalOptions: {
            modalDialogProps: {
                maxWidth: 'xl',
            },
        },
    }), []);
    return (React.createElement(React.Fragment, null,
        isLoading ? (React.createElement(Loader, null)) : alertsCount ? (React.createElement("div", { className: classes.container },
            React.createElement(Warning, { diameter: 90, color: "#E46A68", amount: alertsCount, fontSize: 28, onClick: openModal, title: t('widget:alerts') }))) : (React.createElement(NoAlerts, { widgetType: widget.type })),
        React.createElement(WidgetFooter, { link: link, viewMoreButtonIsDisabled: false })));
};
//# sourceMappingURL=DeviationWidgetXS.js.map